import { Action } from 'redux';
import { OrderedMap } from 'immutable';

import {
    GET_MORE_SCHEDULE_REQUEST,
    GET_MORE_SCHEDULE_RESPONSE,
    GET_MORE_SCHEDULE_ERROR,
    
    GET_SCHEDULE_REQUEST,
    GET_SCHEDULE_RESPONSE,
    GET_SCHEDULE_ERROR,
    
    RESET_SCHEDULE,

    GET_SCHEDULE_EVENT_REQUEST,
    GET_SCHEDULE_EVENT_RESPONSE,
    GET_SCHEDULE_EVENT_ERROR,

    GET_MORE_SCHEDULE_EVENT_REQUEST,
    GET_MORE_SCHEDULE_EVENT_RESPONSE,
    GET_MORE_SCHEDULE_EVENT_ERROR,

    GET_SCHEDULE_EVENT_FORMAT_REQUEST,
    GET_SCHEDULE_EVENT_FORMAT_RESPONSE,
    GET_SCHEDULE_EVENT_FORMAT_ERROR,

    GET_SCHEDULE_PLACE_FORMAT_REQUEST,
    GET_SCHEDULE_PLACE_FORMAT_RESPONSE,
    GET_SCHEDULE_PLACE_FORMAT_ERROR,
    
    TOGGLE_EVENT_FORMAT,
    TOGGLE_PLACE_FORMAT,

    RESET_FORMATS
} from '../../actions/Afisha/schedule';

import { Event } from '../../models/Afisha/Event';
import { Shows } from '../../models/Afisha/Shows';
import { EventShows } from '../../models/Afisha/EventShows';
import Format from '../../models/Afisha/Format';

export interface ScheduleAfishaState {
    schedule: OrderedMap<number, Event>;
    scheduleShows: OrderedMap<number, Shows>;
    loadingSchedule: boolean;
    errorSchedule: any;
    pageSchedule: number;

    scheduleEvent: OrderedMap<number, EventShows>;
    loadingScheduleEvent: boolean;
    errorScheduleEvent: any;
    pageScheduleEvent: number;

    eventFormats: OrderedMap<number, Format>;
    eventToggledFormats: OrderedMap<number, Format>;

    placeFormats: OrderedMap<number, Format>;
    placeToggledFormats: OrderedMap<number, Format>;
}

const initialState: ScheduleAfishaState = {
    schedule: OrderedMap<number, Event>(),
    scheduleShows: OrderedMap<number, Shows>(),
    loadingSchedule: false,
    errorSchedule: null,
    pageSchedule: 1,

    scheduleEvent: OrderedMap<number, EventShows>(),
    loadingScheduleEvent: false,
    errorScheduleEvent: null,
    pageScheduleEvent: 1,

    eventFormats: OrderedMap<number, Format>(),
    eventToggledFormats: OrderedMap<number, Format>(),

    placeFormats: OrderedMap<number, Format>(),
    placeToggledFormats: OrderedMap<number, Format>()
};

export function scheduleAfisha(state: ScheduleAfishaState = initialState, action: Action) {
    switch (action.type) {
        case GET_SCHEDULE_REQUEST: {
            return {
                ...state,
                loadingSchedule: true,
                errorSchedule: initialState.errorSchedule,
                schedule: initialState.schedule
            };
        }
        case GET_SCHEDULE_RESPONSE: {
            const result = (action as any).response.result;
            let scheduleShows = OrderedMap<number, Shows>();
            const schedule = (result.schedule as Array<any>).reduce((prev, cur) => {
                cur.shows.forEach((s: Shows) => {
                    scheduleShows = scheduleShows.has(s.id) ? scheduleShows : scheduleShows.set(s.id, s);
                });
                prev = prev.has(cur.event.id) ? prev : prev.set(cur.event.id, cur.event);
                return prev;
            }, initialState.schedule);
            return {
                ...state,
                loadingSchedule: false,
                schedule,
                scheduleShows,
                pageSchedule: result.pagination.next_page
            };
        }
        case GET_SCHEDULE_ERROR: {
            const errorSchedule = (action as any).error;
            return {
                ...state,
                loadingSchedule: false,
                errorSchedule
            };
        }

        case GET_MORE_SCHEDULE_REQUEST: {
            return {
                ...state,
                errorSchedule: initialState.errorSchedule
            };
        }
        case GET_MORE_SCHEDULE_RESPONSE: {
            const result = (action as any).response.result;
            let scheduleShows = OrderedMap<number, Shows>();
            const schedule = (result.schedule as Array<any>).reduce((prev, cur) => {
                cur.shows.forEach((s: Shows) => {
                    scheduleShows = scheduleShows.has(s.id) ? scheduleShows : scheduleShows.set(s.id, s);
                });
                prev = prev.has(cur.event.id) ? prev : prev.set(cur.event.id, cur.event);
                return prev;
            }, state.schedule);
            return {
                ...state,
                schedule,
                scheduleShows,
                pageSchedule: result.pagination.next_page
            };
        }
        case GET_MORE_SCHEDULE_ERROR: {
            const errorSchedule = (action as any).error;
            return {
                ...state,
                errorSchedule
            };
        }

        case RESET_SCHEDULE: {
            return {
                ...state,
                loadingSchedule: false,
                errorSchedule: initialState.errorSchedule,
                schedule: initialState.schedule,
                pageSchedule: initialState.pageSchedule,
                scheduleShows: initialState.scheduleShows
            };
        }

        case GET_SCHEDULE_EVENT_REQUEST: {
            return {
                ...state,
                loadingScheduleEvent: true,
                errorScheduleEvent: initialState.errorScheduleEvent,
                scheduleEvent: initialState.scheduleEvent
            };
        }
        case GET_SCHEDULE_EVENT_RESPONSE: {
            const result = (action as any).response.result.schedule;
            const scheduleEvent = (result as Array<EventShows>).reduce((prev, cur) => {
                cur.shows = cur.shows.map(it => ({ ...it, place_id: cur.place.id }));
                prev = prev.has(cur.place.id) ? prev : prev.set(cur.place.id, cur);
                return prev;
            }, initialState.scheduleEvent);
            return {
                ...state,
                loadingScheduleEvent: false,
                scheduleEvent,
                pageScheduleEvent: (action as any).response.result.pagination.next_page
            };
        }
        case GET_SCHEDULE_EVENT_ERROR: {
            const errorScheduleEvent = (action as any).error;
            return {
                ...state,
                loadingScheduleEvent: false,
                errorScheduleEvent
            };
        }

        case GET_MORE_SCHEDULE_EVENT_REQUEST: {
            return {
                ...state,
                errorScheduleEvent: initialState.errorScheduleEvent
            };
        }
        case GET_MORE_SCHEDULE_EVENT_RESPONSE: {
            const result = (action as any).response.result.schedule;
            const scheduleEvent = (result as Array<EventShows>).reduce((prev, cur) => {
                cur.shows = cur.shows.map(it => ({ ...it, place_id: cur.place.id }));
                prev = prev.has(cur.place.id) ? prev : prev.set(cur.place.id, cur);
                return prev;
            }, state.scheduleEvent);
            return {
                ...state,
                scheduleEvent,
                pageScheduleEvent: (action as any).response.result.pagination.next_page
            };
        }
        case GET_MORE_SCHEDULE_EVENT_ERROR: {
            const errorScheduleEvent = (action as any).error;
            return {
                ...state,
                errorScheduleEvent
            };
        }

        case GET_SCHEDULE_EVENT_FORMAT_REQUEST: {
            return {
                ...state,
                eventFormats: initialState.eventFormats
            };
        }
        case GET_SCHEDULE_EVENT_FORMAT_RESPONSE: {
            const placeFormats: Array<Format> = (action as any).response.result;
            const setEventFormats = placeFormats.reduce((prev, cur) => prev.set(cur.id, cur), OrderedMap<number, Format>());
            return {
                ...state,
                eventFormats: setEventFormats
            };
        }
        case GET_SCHEDULE_EVENT_FORMAT_ERROR: {
            return {
                ...state
            };
        }

        case TOGGLE_EVENT_FORMAT: {
            const format = (action as any).format;
            let formats: OrderedMap<number, Format>;
            if (state.eventToggledFormats.has(format.id)) {
                formats = state.eventToggledFormats.delete(format.id);
            } else {
                formats = state.eventToggledFormats.set(format.id, format);
            }
            return {
                ...state,
                eventToggledFormats: formats
            };
        }

        case GET_SCHEDULE_PLACE_FORMAT_REQUEST: {
            return {
                ...state,
                placeFormats: initialState.placeFormats
            };
        }
        case GET_SCHEDULE_PLACE_FORMAT_RESPONSE: {
            const placeFormats: Array<Format> = (action as any).response.result;
            const setPlaceFormats = placeFormats.reduce((prev, cur) => prev.set(cur.id, cur), OrderedMap<number, Format>());
            return {
                ...state,
                placeFormats: setPlaceFormats
            };
        }
        case GET_SCHEDULE_PLACE_FORMAT_ERROR: {
            return {
                ...state
            };
        }
        
        case TOGGLE_PLACE_FORMAT: {
            const format = (action as any).format;
            let formats: OrderedMap<number, Format>;
            if (state.placeToggledFormats.has(format.id)) {
                formats = state.placeToggledFormats.delete(format.id);
            } else {
                formats = state.placeToggledFormats.set(format.id, format);
            }
            return {
                ...state,
                placeToggledFormats: formats
            };
        }
        case RESET_FORMATS: {
            return {
                ...state,
                placeToggledFormats: initialState.placeToggledFormats,
                eventToggledFormats: initialState.eventToggledFormats,
            };
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/reducers/Afisha/schedule.ts